import MobileDetect from 'mobile-detect';

export default class Screenshotter {

    beginShooting(move) {
        const defaultSize = 1080 / window.devicePixelRatio;
        let imgSize = defaultSize;
        const md = new MobileDetect(window.navigator.userAgent);
        ////console.log('CHE: md.os()', md.os());
        if (md.os() != null && md.os().toLowerCase() == 'ios') {
            imgSize = Math.max(256, ($(document).height()), ($(document).width()));
        }
        this.blur = STAGE.freezeRendererAndBlur();
        this.saved = {
            position: STAGE.camera.position.clone(),
            rotation: STAGE.camera.rotation.clone(),
            stageSize: {
                height: $('.threejsRenderer').children('canvas').height(),
                width: $('.threejsRenderer').children('canvas').width()
            }
        };
        STAGE.setRendererToSize(imgSize, imgSize);
        STAGE.resetOrbitControl();
        STAGE.renderSceneOnce();
        // STAGE.setDirty();
    }

    shoot(callback, filename) {
        const mimetype = filename.endsWith('.png')
            ? 'image/png'
            : 'image/jpeg';
        // STAGE.setDirty();
        STAGE.renderToBlob(mimetype, callback);
    }

    endShooting() {
        STAGE.camera.position.copy(this.saved.position);
        STAGE.camera.rotation.copy(this.saved.rotation);
        $('.threejsRenderer').children('canvas').height(this.saved.stageSize.height);
        $('.threejsRenderer').children('canvas').width(this.saved.stageSize.width);
        STAGE.setRendererToSize(this.saved.stageSize.width, this.saved.stageSize.height);
        this.blur.hideDialog();
        APP.model.setDirty();
        STAGE.setDirty();
    }

}
